export default () => {
    const noProductsInOrder = document.querySelector('.js-noProductsInOrder');
    
    if(noProductsInOrder){
      noProductsInOrder.classList.add('is-active');
    }

}